import { Button, IconButton, Tooltip } from "@chakra-ui/react";
import React from "react";
import { FiMessageCircle } from "react-icons/fi";
import { useIntercom } from "react-use-intercom";

export function NavbarSupportButton({ isCollapsed }: { isCollapsed: boolean }) {
  const { show, hide, isOpen } = useIntercom();

  const onClick = () => {
    if (isOpen) {
      hide();
    } else {
      show();
    }
  };

  if (isCollapsed) {
    return (
      <Tooltip label="Support" placement="right" hasArrow>
        <IconButton
          aria-label="Support"
          w="full"
          colorScheme="gray"
          variant="ghost"
          icon={<FiMessageCircle size="1.5rem" />}
          onClick={onClick}
        />
      </Tooltip>
    );
  }

  return (
    <Button
      w="full"
      colorScheme="gray"
      variant="ghost"
      justifyContent="flex-start"
      leftIcon={<FiMessageCircle size="1.5rem" />}
      onClick={onClick}
    >
      Support
    </Button>
  );
}
